// Import SASS
import '../sass/style.scss';

// Import scripts
import './modules/navigation';
import { heroSlider } from './modules/sliders';
import objectFitImages from 'object-fit-images';
import './modules/skip-link-focus-fix';
import { moveOnScroll } from './modules/animations';

// Object-fit fix
objectFitImages();

// Sliders
heroSlider('.hero-slider');

// Animations for faded titles
const titles = document.querySelectorAll('.faded-title');
moveOnScroll(titles);